import { css, mediaQueries } from '@eti/styles';
import { Dialog } from '@etg/wings';
import { useTranslation } from '@eti/providers';
import SeatMapContent from '../containers/SeatMapContentContainer';
import { jsx as _jsx } from "react/jsx-runtime";
const seatMapDialogStyles = css`
  background: #fff;
  border-radius: 0.1875rem;
  box-shadow: 0 0 10px rgb(0 0 0 / 20%);
  height: inherit;
  max-height: 100%;
  outline: none;
  position: absolute;

  > div {
    height: 100%;
  }

  @media ${mediaQueries.medium.up} {
    height: 90vh;
    inset: 20px;
    margin: auto;
    max-width: 48rem;
  }

  @media ${mediaQueries.large.up} {
    max-width: 1200px;
  }

  @media (min-width: 1200px) {
    width: 1200px;
  }
`;
const SeatMapOverlay = _ref => {
  let {
    show,
    form,
    order,
    setIsSeatMapModalOpen,
    travelers,
    bounds
  } = _ref;
  const {
    t
  } = useTranslation();
  return /*#__PURE__*/_jsx(Dialog, {
    className: seatMapDialogStyles,
    closeButtonAriaLabel: t('ScreenReader.CloseButtonDialog.AriaLabel.Text'),
    "data-testid": "seatMap-dialog",
    isOpen: show,
    title: "" // To be replaced with a text key
    ,
    children: /*#__PURE__*/_jsx(SeatMapContent, {
      bounds: bounds,
      form: form,
      order: order,
      setIsSeatMapModalOpen: setIsSeatMapModalOpen,
      travelers: travelers
    })
  });
};
export default SeatMapOverlay;
//# sourceMappingURL=SeatMapOverlay.js.map